import SideNav from "./side-navigation";
import Tabs from "./tabs";
import Accordions from "./accordions";
import Sliders from "./sliders";
import Utility from "./utility";
import Stats from "./stats";
import MoreProgramsSlider from "./more-programs-slider-plugin";
import AOISlider from "./aoi-slider";
import TestimonialsSliderPlugin from "./testimonials-slider";
import ImageSliderPlugin from "./image-slider";
import VideoSliderPlugin from "./video-slider";
import WysiwygSliderPlugin from "./wysiwyg-slider";
import Library from "./library";
import Cards from "./cards";
import FullWidth from "./full-width";
import Modal from "./modal";
import StudentGroups from "./student-groups";
import ExpertBioCategories from "./expert-bio-categories";
import MultiSelect from "./multi-select";
import Video from "./video";
import VideoBanner from "./video-banner";
import VideoModal from "./video-modal";
import CustomGoogleMap from "./custom-google-map";
import Footer from "./footer";
//import BannerScroll from "./sc-banner-scroll";

class SaitApp {
    utilities: Utility = Utility;
    sidenav: SideNav;
    accordions: Accordions;
    tabs: Tabs;
    sliders: Sliders;
    stats: Stats;
    library: Library;
    //cards: Cards;
    fullWidth: FullWidth;
    modal: Modal;
    studentGroups: StudentGroups;
    expertBioCategories: ExpertBioCategories;
    multiSelect: MultiSelect;
    video: Video;
    videoBanner: VideoBanner;
    videoModal: VideoModal;
    sideNav: SideNav;
    customGoogleMap: CustomGoogleMap;
    footer: Footer;
    //BannerScroll: BannerScroll;

    constructor() {
        this.init();
    }

    init() {
        this.tabs = new Tabs();
        this.tabs.start();
        let sliderPlugins = [
            MoreProgramsSlider,
            TestimonialsSliderPlugin,
            ImageSliderPlugin,
            VideoSliderPlugin,
            WysiwygSliderPlugin,
            AOISlider
        ];
        this.accordions = new Accordions();
        this.accordions.start();
        this.sliders = new Sliders(sliderPlugins);
        this.stats = new Stats();
        this.stats.start();
        this.library = new Library();
        this.library.init();
        //this.cards = new Cards();
        this.fullWidth = new FullWidth();
        this.modal = new Modal();
        this.studentGroups = new StudentGroups();
        this.studentGroups.update();
        this.expertBioCategories = new ExpertBioCategories();
        this.multiSelect = new MultiSelect();
        this.video = new Video();
        this.videoBanner = new VideoBanner();
        this.videoModal = new VideoModal();
        this.sideNav = new SideNav();
        this.customGoogleMap = new CustomGoogleMap();
        this.footer = new Footer();
        //this.BannerScroll = new BannerScroll();
    }
}
export default SaitApp;